import React from 'react'
import { Text } from '@chakra-ui/react'

export default (props) => {
  return <Text {...props} />
}
